import Vue from 'vue';
import '@/plugins/filter';
// Json Viewer imports
import JsonViewer from 'vue-json-viewer';
import VueClipboard from 'vue-clipboard2';
import vuetify from '@/plugins/vuetify';


import App from '@/App.vue';
import router from '@/router';
import store from '@/store';

import '@/style/global.scss';

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.use(JsonViewer);

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
}).$mount('#app');
